import DeleteIcon from "@mui/icons-material/Delete";
import { Tooltip } from "@mui/material";

import SuiBox from "components/SuiBox";
import SuiButton from "components/SuiButton";
import SuiInput from "components/SuiInput";
import SuiSelect from "components/SuiSelect";
import SuiBadge from "components/SuiBadge";
import SuiTypography from "components/SuiTypography";
import ImageCardWrapper from "components/UpStyled/ImageCardWrapper";
import Prompt, { SimplePrompt } from "components/UpStyled/Prompt";
import { forwardRef, useCallback, useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import "react-multi-carousel/lib/styles.css";
import api from "services/api";
import { saveAs } from "file-saver";

import colors from "assets/theme/base/colors";
import SuiBadgeDot from "components/SuiBadgeDot";

import RestartAltIcon from "@mui/icons-material/RestartAlt";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";

import { capitalCase } from "capital-case";
import { Button, Empty } from "antd";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

import Lightbox from "yet-another-react-lightbox";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Download from "yet-another-react-lightbox/plugins/download";
import Thumbnails from "yet-another-react-lightbox/plugins/thumbnails";
import "yet-another-react-lightbox/plugins/captions.css";

import { useForm, Controller } from "react-hook-form";

import CircularProgress from "@mui/material/CircularProgress";
import ResultImageItem from "./ResultImageItem";

const ProjectResultItem = ({
  product,
  projectData,
  setProjectData,
  allVisibleToggle,
  handleDownloadUrls,
}) => {
  const [imgsViewerVisible, setImgsViewerVisible] = useState(false);
  const [imgsViewerCurrent, setImgsViewerCurrent] = useState(0);

  const [deleteVisible, setDeleteVisible] = useState(false); //delete the image in dataset
  const [selectedUrls, setSelectedUrls] = useState([]);
  const [deleteBatchVisible, setDeleteBatchVisible] = useState(false); //delete unselected images for one product

  const [sketchImgsViewerVisible, setSketchImgsViewerVisible] = useState(false);
  const [selectedSketchImg, setSelectedSketchImg] = useState();
  const [editTaskVisible, setEditTaskVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const pathnames = window.location.pathname.split("/");
  let uwproject_id = null;
  if (pathnames.length > 1 && pathnames[pathnames.length - 2] == "tasks") {
    uwproject_id = pathnames[pathnames.length - 1];
  }
  const lightboxRef = useRef(null);
  const promptRef = useRef(null);

  let resultData = projectData?.products?.ai_result || [];

  let images = [];

  for (let i = 0; i < resultData.length; i++) {
    let rd_images = resultData[i]?.images || [];
    for (let j = 0; j < rd_images.length; j++) {
      images.push({
        src: rd_images[j],
        code: resultData[i]?.task_meta?.code,
        product_id: resultData[i]?.task_meta?.product_id,
        viewpoint: resultData[i]?.task_meta?.viewpoint,
      });
    }
  }
  const taskConfig = product?.config?.[0] || {};

  const {
    register,
    handleSubmit,
    trigger,
    setValue,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues: taskConfig?.task_meta });

  const openImgsViewer = () => setImgsViewerVisible(true);
  const closeImgsViewer = () => setImgsViewerVisible(false);

  const handleFullScreen = (e, url) => {
    const index = images.findIndex((x) => x.src == url);
    if (index > -1) {
      setImgsViewerCurrent(index);
      openImgsViewer();
    }
  };

  const handleDeleteResultImage = async (e, imgUrls) => {
    const newresultData = [];

    let ai_results = projectData?.products?.ai_result || [];

    for (let i = 0; i < ai_results.length; i++) {
      const newAiResult = {
        ...ai_results[i],
        images: ai_results[i]?.images?.filter((url, inx) => !imgUrls.includes(url)) || [],
      };

      newresultData.push(newAiResult);
    }

    try {
      var payload = {
        products: {
          ai_result: newresultData,
          data: projectData?.products?.data || [],
        },
      };

      const { data } = await api.uwProject.update(uwproject_id, payload);
      setProjectData(data?.updated);
      toast.success("Delete successfully!");
    } catch (err) {
      toast.error("Delete failed!");
    }
  };

  const resultMap = {};
  for (let i = 0; i < resultData.length; i++) {
    let productId = resultData[i]?.task_meta?.product_id;
    if (resultMap?.[productId]) {
      resultMap[productId].push(resultData[i]);
    } else {
      resultMap[productId] = [resultData[i]];
    }
  }

  const reRunAiProductJob = async (project_id, product_id) => {
    try {
      let meta = projectData?.metadata || {};
      let old_status = meta?.task_status || [];
      old_status.push(product_id);
      let newMeta = {
        ...meta,
        task_status: old_status,
      };
      await updateProjectMetaData(newMeta);
      const { data } = api.uwProject.projectAiTasks({ id: project_id, product_ids: [product_id] });

      toast.success("Successfully rerun the job!");
    } catch (err) {
      toast.error("Failed to rerun the job!");
    }
  };

  const updateProjectMetaData = async (payload) => {
    try {
      const { data } = await api.uwProject.update(projectData.id, { metadata: payload });
      setProjectData(data?.updated);
    } catch (err) {
      toast.error("Failed to update task information!");
    }
  };

  const handleToggleImage = async (item) => {
    if (!item.code) {
      return toast.error("Failed to find the item code!");
    }

    try {
      let selected_images = projectData?.metadata?.selected_images || {};
      if (selected_images?.[item.code]?.src == item.src) {
        delete selected_images[item.code];
      } else {
        selected_images[item.code] = item;
      }

      let meta = projectData?.metadata || {};

      meta["selected_images"] = selected_images;

      await updateProjectMetaData(meta);
    } catch (err) {
      toast.error("Failed to select the image!");
    }
  };

  const markDoneProduct = async (product_id) => {
    try {
      let productData = projectData?.products?.data || [];
      for (let i = 0; i < productData.length; i++) {
        if (productData[i]["id"] == product_id) {
          productData[i]["mark_done"] = !!!productData[i]["mark_done"];
        }
      }

      const { data } = await api.uwProject.update(projectData.id, {
        products: {
          data: productData,
          ai_result: projectData.products.ai_result,
        },
      });
      setProjectData(data?.updated);
    } catch (err) {
      toast.error("Failed to update task information!");
    }
  };

  const handleRunAdvance = async (taskConfig) => {
    try {
      setLoading(true);
      let meta = projectData?.metadata || {};
      let old_status = meta?.task_status || [];
      old_status.push(product.id);
      let newMeta = {
        ...meta,
        task_status: old_status,
      };
      await updateProjectMetaData(newMeta);
      const { data } = api.uwProject.projectAiTasks({
        id: projectData.id,
        product_ids: [product.id],
        taskConfig: taskConfig,
      });
      setLoading(false);

      toast.success("Successfully rerun the job!");
    } catch (err) {
      setLoading(false);

      console.log(err);
      toast.error("Failed to rerun the job!");
    }
  };

  let results = resultMap?.[product.id] || [];
  let sketch_set = new Set();

  let resultImages = [];
  for (let i = 0; i < results.length; i++) {
    for (let j = 0; j < results[i].images?.length; j++) {
      resultImages.push({
        src: results[i].images[j],
        code: results[i]?.task_meta?.code,
        product_id: results[i]?.task_meta?.product_id,
        viewpoint: results[i]?.task_meta?.viewpoint,
      });
    }
    sketch_set.add(results[i]?.task_meta?.conditional);
  }
  let conditional_imgs = Array.from(sketch_set);

  return (
    <SuiBox>
      <div style={{ display: "relative" }}>
        <Lightbox
          controller={{ ref: lightboxRef }}
          open={imgsViewerVisible}
          close={closeImgsViewer}
          slides={images.map((x, index) => ({
            src: x.src,
            id: index,
            code: x.code,
            viewpoint: x.viewpoint,
          }))}
          plugins={[Zoom, Download, Thumbnails]}
          zoom={{ maxZoomPixelRatio: 3 }}
          index={imgsViewerCurrent}
          carousel={{ finite: true }}
        />
      </div>
      <Lightbox
        open={sketchImgsViewerVisible}
        close={() => {
          setSketchImgsViewerVisible(false);
        }}
        slides={[{ src: selectedSketchImg, id: "sketch_img" }]}
        plugins={[Zoom, Download]}
        zoom={{ maxZoomPixelRatio: 3 }}
        index={0}
      />

      <SuiBox mb={1} height="100%">
        {!allVisibleToggle && product?.mark_done ? (
          <div />
        ) : (
          <div>
            <SuiBox
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 0.5,
                px: 1,
                mb: 0.5,
                height: 74,
                backgroundColor: colors.light.main,
              }}
            >
              <div>
                <SuiTypography variant="body1" fontWeight="bold" color="dark">
                  {product?.name || ""}

                  {!product?.mark_done ? (
                    <Tooltip title={"Mark Done"}>
                      <SuiBadge
                        variant="contained"
                        color={"info"}
                        size="sm"
                        sx={{ ml: 2, cursor: "pointer", mb: 0.5 }}
                        badgeContent={"Working"}
                        container
                        onClick={() => {
                          markDoneProduct(product.id);
                        }}
                      />
                    </Tooltip>
                  ) : (
                    <Tooltip title={"Mark Working"}>
                      <SuiBadge
                        variant="contained"
                        color={"success"}
                        size="sm"
                        sx={{ ml: 2, cursor: "pointer", mb: 0.5 }}
                        badgeContent={"Done"}
                        container
                        onClick={() => {
                          markDoneProduct(product.id);
                        }}
                      />
                    </Tooltip>
                  )}
                </SuiTypography>

                <SuiTypography>
                  {product?.code ? product.code.toUpperCase() : ""}
                  {projectData?.metadata?.task_status &&
                  projectData?.metadata?.task_status.includes(product.id) ? (
                    <SuiBadgeDot
                      color="info"
                      badgeContent={"Processing"}
                      sx={{ display: "inline" }}
                    />
                  ) : (
                    <SuiButton
                      color="dark"
                      sx={{
                        padding: "0px 12px",
                        fontSize: 12,
                        lineHeight: 0,
                        margin: "0px 4px",
                        minHeight: 24,
                        minWidth: 32,
                        textTransform: "none",
                        borderRadius: "4px",
                      }}
                      size="small"
                      onClick={() => {
                        reRunAiProductJob(projectData.id, product.id);
                      }}
                    >
                      <RestartAltIcon sx={{ mr: 0.5 }} />
                      ReRun
                    </SuiButton>
                  )}
                  <SuiButton
                    color="info"
                    sx={{
                      padding: "0px 12px",
                      fontSize: 12,
                      lineHeight: 0,
                      margin: "0px 4px",
                      minHeight: 24,
                      minWidth: 32,
                      textTransform: "none",
                      borderRadius: "4px",
                    }}
                    size="small"
                    onClick={() => {
                      if (!editTaskVisible) {
                        reset(taskConfig?.task_meta);
                      }
                      setEditTaskVisible(!editTaskVisible);
                    }}
                  >
                    <SettingsSuggestIcon sx={{ mr: 0.5 }} />
                    Advance
                  </SuiButton>
                  <SuiButton
                    color="error"
                    variant="text"
                    sx={{
                      padding: "0px 12px",
                      fontSize: 12,
                      lineHeight: 0,
                      margin: "0px 4px",
                      minHeight: 24,
                      minWidth: 32,
                      textTransform: "none",
                      borderRadius: "4px",
                    }}
                    size="small"
                    onClick={() => {
                      setDeleteBatchVisible(true);
                      let deleteUrls = [];
                      let selected_images =
                        projectData?.metadata?.selected_images?.[product?.code] || {};

                      for (let i = 0; i < resultImages.length; i++) {
                        if (selected_images?.src != resultImages[i].src) {
                          deleteUrls.push(resultImages[i].src);
                        }
                      }

                      setSelectedUrls(deleteUrls);
                    }}
                  >
                    <DeleteIcon sx={{ mr: 0.5 }} />
                    Delete Unselected
                  </SuiButton>
                </SuiTypography>
              </div>
              <SuiBox sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                <div className="xsmall:hidden small:hidden medium:inline large:inline">
                  <div>
                    <strong>Front:</strong> {product?.content?.front_panels_fabric}{" "}
                  </div>

                  <div>
                    <strong>Back & Side:</strong> {product?.content?.backs_and_sides_fabric}{" "}
                  </div>

                  <div>
                    <strong>Visor:</strong> {product?.content?.visor_fabric}
                  </div>
                </div>
                <div className="xsmall:hidden small:hidden medium:flex large:flex items-center gap-2">
                  <SuiTypography variant="body1" fontWeight="bold" color="dark">
                    Sketches:
                  </SuiTypography>
                  {conditional_imgs.map((img) => (
                    <SuiBox
                      display="flex"
                      gap={0.5}
                      alignItems="center"
                      sx={{ minWidth: 70, overflow: "hidden" }}
                    >
                      <div>
                        <ImageCardWrapper
                          data={{ url: img, type: "image/*" }}
                          alt={"image_conditional"}
                          width={65}
                          height={65}
                          sx={{
                            cursor: "pointer",
                            filter: "invert(1)",
                            "-webkit-filter": "invert(1)",
                          }}
                          onClick={() => {
                            setSelectedSketchImg(img);
                            setSketchImgsViewerVisible(true);
                          }}
                        />
                      </div>
                    </SuiBox>
                  ))}
                </div>
              </SuiBox>
            </SuiBox>
            {editTaskVisible ? (
              <div className="bg-slate-100">
                <form onSubmit={handleSubmit(handleRunAdvance)}>
                  <div className="flex gap-2 flew-wrap px-4 py-2">
                    <div className="flex-grow">
                      <div>
                        <SuiBox
                          mb={1}
                          ml={0.5}
                          lineHeight={0}
                          className="flex justify-between items-center"
                        >
                          <SuiTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                            required
                          >
                            Prompt
                          </SuiTypography>
                          <SuiButton
                            color={loading ? "info" : "info"}
                            sx={{
                              padding: "0px 12px",
                              fontSize: 12,
                              lineHeight: 0,
                              margin: "0px 4px",
                              minHeight: 24,
                              minWidth: 32,
                              textTransform: "none",
                              borderRadius: "4px",
                            }}
                            size="small"
                            type="submit"
                            disabled={loading}
                          >
                            {loading ? (
                              <CircularProgress size="small" className="w-4 h-4 mr-1 text-white" />
                            ) : null}
                            Run
                          </SuiButton>
                        </SuiBox>
                        <SuiInput placeholder="Prompt" rows={5} multiline {...register("prompt")} />
                      </div>
                    </div>
                    <div className="min-w-[400px] grid grid-cols-2 gap-2">
                      <div className="col-span-1">
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <Tooltip title="Determines how much weight to assign to the sketch">
                            <SuiTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                              required
                            >
                              Conditioning Scale(0-3)
                            </SuiTypography>{" "}
                          </Tooltip>
                        </SuiBox>
                        <SuiInput
                          placeholder="1.1"
                          required={true}
                          type={"number"}
                          inputProps={{
                            max: 3,
                            min: 0,
                            step: 0.05,
                          }}
                          {...register("controlnet_conditioning_scale")}
                        />
                      </div>
                      <div className="col-span-1">
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <Tooltip title="Determines how much weight to assign to the prompt">
                            <SuiTypography
                              component="label"
                              variant="caption"
                              fontWeight="bold"
                              textTransform="capitalize"
                              required
                            >
                              Guidance Scale(0-20)
                            </SuiTypography>{" "}
                          </Tooltip>
                        </SuiBox>
                        <SuiInput
                          placeholder="8.0"
                          required={true}
                          type={"number"}
                          inputProps={{
                            max: 20,
                            min: 0,
                            step: 0.5,
                          }}
                          {...register("guidance_scale")}
                        />
                      </div>
                      <div className="col-span-1">
                        <SuiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                          <SuiTypography
                            component="label"
                            variant="caption"
                            fontWeight="bold"
                            textTransform="capitalize"
                            required
                          >
                            Batch Size
                          </SuiTypography>
                        </SuiBox>
                        <SuiInput
                          placeholder="Batch Size"
                          required={true}
                          type={"number"}
                          inputProps={{
                            max: 6,
                            min: 1,
                            step: 1,
                          }}
                          {...register("batch_size")}
                        />
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            ) : null}

            <ResponsiveMasonry
              columnsCountBreakPoints={{ 200: 1, 500: 2, 700: 3, 1000: 4, 1300: 5, 1600: 6 }}
            >
              <Masonry>
                {resultImages.map((item, index) => {
                  const isSelected =
                    projectData?.metadata?.selected_images?.[item.code]?.src == item.src
                      ? true
                      : false;

                  return (
                    <ResultImageItem
                      projectId={uwproject_id}
                      item={item}
                      index={index}
                      isSelected={isSelected}
                      handleToggleImage={handleToggleImage}
                      setDeleteVisible={setDeleteVisible}
                      setSelectedUrls={setSelectedUrls}
                      handleFullScreen={handleFullScreen}
                      handleDownloadUrls={handleDownloadUrls}
                      setProjectData={setProjectData}
                    />
                  );
                })}
              </Masonry>
            </ResponsiveMasonry>
            {resultImages.length == 0 ? (
              <SuiBox height="100%">
                {" "}
                <Empty />{" "}
              </SuiBox>
            ) : null}
          </div>
        )}
      </SuiBox>

      {deleteVisible ? (
        <Prompt
          heading="Delete Confirmation"
          text={`Are you certain you want to delete this result image?`}
          visible={deleteVisible}
          okText="Delete"
          okColor="error"
          handleOk={(e) => {
            handleDeleteResultImage(e, selectedUrls);
            setDeleteVisible(false);
          }}
          handleClose={() => setDeleteVisible(false)}
        />
      ) : null}

      {deleteBatchVisible ? (
        <Prompt
          heading="Delete Confirmation"
          text={
            <SuiTypography>
              Are you certain you want to delete all <strong>unselected</strong> images?
            </SuiTypography>
          }
          visible={deleteBatchVisible}
          okText="Delete"
          okColor="error"
          handleOk={(e) => {
            handleDeleteResultImage(e, selectedUrls);
            setDeleteBatchVisible(false);
          }}
          handleClose={() => setDeleteBatchVisible(false)}
        />
      ) : null}
    </SuiBox>
  );
};

export default ProjectResultItem;
